<script>
  import { onMount } from "svelte";
  import { Router, Link, Route } from "svelte-routing";
  import { activeMenu } from "../stores";
  import List from "./list/index.html";
  import Update from "./update/index.html";
  import MODULES from "../utils/modules.js" 
  import Forbidden from "../forbidden.html" 
  import ArchievedList from "./archivedList/index.html";

  onMount(function () {
    activeMenu.set("taskmanagement");
  });
</script>

<Router>
  <Route path="edit/:id" let:params>
    {#if MODULES.hasAccess(MODULES.EDIT_TASK)}
    <Update _id={params.id} />
    {:else}
    <Forbidden />
    {/if}
  </Route>
  <Route path="archived">
    <ArchievedList ></ArchievedList>
</Route>
  <Route path="">
    <List />
  </Route>
</Router>
